import React from 'react'
import NotFoundLayout from '../../layouts/NotFound'

const NotFoundPtBR = ({ location }) => {
  return (
    <NotFoundLayout location={location}>
      <h2>
        Que pena, esta página não existe. Que tal visitar nossas outras páginas?
      </h2>
      <p>Ainda não encontrou o que estava procurando?</p>
      <p>
        Fale com a gente em nossa{' '}
        <a
          href="https://atendimento.hotmart.com.br"
          target="_blank"
          rel="noopener noreferrer"
        >
          central de suporte
        </a>
      </p>
    </NotFoundLayout>
  )
}

export default NotFoundPtBR
